import { render, staticRenderFns } from "./WorkoutUsage.vue?vue&type=template&id=4706dfb0&scoped=true&"
import script from "./WorkoutUsage.vue?vue&type=script&lang=js&"
export * from "./WorkoutUsage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4706dfb0",
  null
  
)

export default component.exports